import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';

import { HeroModule } from 'src/app/shared/components/hero/hero.module';
import { ProductChoiceModule } from "../../../shared/components/product-choice/product-choice.module";

import { SelfAttendanceAutoRechargeDisableComponent } from './auto-recharge-disable.component';
import {AlertModule} from "../../../shared/components/alert/alert.module";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    
    MatButtonModule,
    HeroModule,
    ProductChoiceModule,
    AlertModule,
    MatProgressSpinnerModule,
    MatIconModule
  ],
  exports: [
    SelfAttendanceAutoRechargeDisableComponent
  ],
  providers: [
  ],
  declarations: [
    SelfAttendanceAutoRechargeDisableComponent
  ]
})

export class SelfAttendanceAutoRechargeDisableModule { }
